import { render, staticRenderFns } from "./iPreview.vue?vue&type=template&id=2465be20&scoped=true&"
import script from "./iPreview.vue?vue&type=script&lang=js&"
export * from "./iPreview.vue?vue&type=script&lang=js&"
import style0 from "./iPreview.vue?vue&type=style&index=0&id=2465be20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465be20",
  null
  
)

export default component.exports